"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var owa_feature_flags_1 = require("owa-feature-flags");
var mobx_react_1 = require("mobx-react");
var Toggle_1 = require("office-ui-fabric-react/lib/components/Toggle");
var styles = require('./FeatureFlagsListItem.scss');
var FeatureFlagsListItem = /** @class */ (function (_super) {
    tslib_1.__extends(FeatureFlagsListItem, _super);
    function FeatureFlagsListItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeatureFlagsListItem.prototype.render = function () {
        var _a = this.props, name = _a.name, isOn = _a.isOn;
        return (React.createElement(Toggle_1.Toggle, { checked: isOn, onText: name, offText: name, className: styles.toggle, onChanged: function (value) { return owa_feature_flags_1.setFeatureFlag(name, !isOn); } }));
    };
    FeatureFlagsListItem = tslib_1.__decorate([
        mobx_react_1.observer
    ], FeatureFlagsListItem);
    return FeatureFlagsListItem;
}(React.Component));
exports.default = FeatureFlagsListItem;
//# sourceMappingURL=FeatureFlagsListItem.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/FeatureFlags/FeatureFlagsListItem.js
// module id = 6203
// module chunks = 38